import React from 'react';
import { Row, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';

import { useVisibleModal } from 'hooks';

import OktaSsoModal from './OktaSsoModal';
import SecurityLabel from './SecurityLabel';
import oktaSrc from 'assets/security/okta.png';

const OktaLabel = ({ oktaEmail }) => {
  return (
    <SecurityLabel
      labelImageSrc={oktaSrc}
      labelTitle='Okta Email'
      detailText={oktaEmail || 'N/A'}
    />
  );
};

const OktaControl = ({ userProfile }) => {
  const [visible, { onModal, offModal }] = useVisibleModal();

  return (
    <div>
      <Button type='primary' onClick={onModal} icon={<EditOutlined />}>
        Change okta email
      </Button>
      <OktaSsoModal
        visible={visible}
        offModal={offModal}
        userProfile={userProfile}
      />
    </div>
  );
};

const OktaStatus = () => {
  return <div />;
};

const OktaSso = {
  Label: OktaLabel,
  Control: OktaControl,
  Status: OktaStatus,
};

export default OktaSso;
